import Program from 'wwg-utilities/dist/collections/program';
import paysYouIcon from '../../../lib/config/project/paysYouIcon';
import Alert from '../../icons/Alert';
import CallOutButton from '../../shared/CallOutButton';
import BottomBar from '../BottomBar';
import LocationIcon from '../../icons/Location';

interface BannerProps {
  bigImage: string;
  draft?: boolean;
  program: Program;
  region: string;
}

const Banner: React.FC<BannerProps> = ({
  bigImage,
  draft,
  program,
  region,
}) => {
  return (
    <>
      <section
        className="w-screen col-start-1 col-end-5 row-start-1 row-end-2 bg-center bg-no-repeat bg-cover h-75vh min-h-64"
        style={{
          backgroundImage: `linear-gradient(0deg, #000000C4 0%, #29292971 50%, #54545458 100%), url(${bigImage})`,
        }}
      >
        {draft && program._status === 'draft' && (
          <div className="absolute left-0 right-0 p-6 text-center text-white bg-red top-10 md:top-20">
            <div className="container flex items-center mx-auto">
              <Alert className="w-5 h-5 stroke-white" />
              &nbsp;&nbsp;
              <p className="text-sm text-left md:text-base">This is a draft.</p>
            </div>
          </div>
        )}

        {draft && program._status === 'published' && (
          <div className="absolute left-0 right-0 p-6 text-center text-white bg-green top-10 md:top-20">
            <div className="container flex items-center mx-auto">
              <Alert className="w-5 h-5 stroke-white" />
              &nbsp;&nbsp;
              <p className="text-sm text-left md:text-base">
                Your drafts have all been published. This is the live version of
                your program page.
              </p>
            </div>
          </div>
        )}

        <section
          id="container"
          className="container relative h-full py-8 mx-auto"
        >
          <section className="block lg:hidden">
            <BottomBar program={program} region={region} />
          </section>
          <section className="flex flex-col justify-between h-full max-w-full md:max-w-3/5">
            <section className="flex flex-wrap">
              {program.costMerits?.includes('Pays you') && (
                <CallOutButton icon={paysYouIcon} label="Pays you!" />
              )}
            </section>
            <section className="lg:mr-32">
              <h1 className="text-3xl font-bold leading-[65px] text-white programName md:text-5xl font-heading">
                {program.name}
              </h1>
              <p className="my-4 text-2xl font-light text-white providerName font-base">
                at {(program as Program).providerName}
              </p>
              <p className="items-center block my-4 text-base font-bold text-white md:flex font-heading md:text-lg">
                <span
                  className={`bg-location leading-10 whitespace-nowrap rounded-lg text-location-text pl-2 pr-4 py-1 my-1 inline-block `}
                >
                  <LocationIcon className="inline-block w-5 h-5" />
                  &nbsp;&nbsp; New Orleans Catalog
                </span>
                {program.gradRate && (
                  <div className="flex items-center my-4 md:my-0">
                    <span className="font-light">
                      &nbsp;&nbsp;|&nbsp;&nbsp;
                    </span>
                    <span className="text-white ">
                      {' '}
                      {program.gradRate}% Graduation Rate
                    </span>
                  </div>
                )}
              </p>
            </section>
          </section>
        </section>
      </section>
    </>
  );
};

export default Banner;
